import config from "../config";
export const API_PREFIX = `${config.API_BASE_URL}`;

// tasks
export const TASKS_ENDPOINT = `${API_PREFIX}/tasks`;

// configs
export const CONFIGS_ENDPOINT = `${API_PREFIX}/configs`;

// error codes
export const HTTP_CLIENT_ERROR = '500';
